import * as React from 'react';

import { Svg, SvgImage, SvgProps } from '@rbilabs/universal-components';

export const FriesOffersSvg = (props: SvgProps) => (
  <Svg viewBox="0 100 400 400" fill="none">
    <SvgImage height="600" width="400" href={require('./Fries-min.png')} />
  </Svg>
);
